import { useState } from 'react'

import { F0Checkbox, F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface RoleRateChangeModalProps {
  onConfirm: (dontShowAgain: boolean) => void
  onCancel: () => void
}

const RoleRateChangeModal = ({ onConfirm, onCancel }: RoleRateChangeModalProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false)

  return (
    <F0Dialog
      width="sm"
      isOpen
      onClose={onCancel}
      title={i18n.t('finance.quotes.role_rate_change_modal.title')}
      description={i18n.t('finance.quotes.role_rate_change_modal.description')}
      primaryAction={{
        label: i18n.t('finance.quotes.role_rate_change_modal.confirm'),
        onClick: () => onConfirm(dontShowAgain),
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onCancel,
      }}
    >
      <F0Checkbox
        title={i18n.t('finance.quotes.role_rate_change_modal.dont_show_again')}
        checked={dontShowAgain}
        onCheckedChange={(checked) => setDontShowAgain(checked === true)}
      />
    </F0Dialog>
  )
}

export default RoleRateChangeModal
